class FadeInAnimate extends HTMLElement {
  constructor() {
    super();
    this._animiateMethods = {
      fadeIn: 'fadeIn-animated-element',
      smoothIn: 'fadeIn-animated-element-smooth',
      slowIn: 'fadeIn-animated-element-slow',
      slowInPro: 'fadeIn-animated-element-very_slow'
    };

    this._elementsSelectors = this.getAttribute('selectors') || '';
    this._textSelector = this.getAttribute('textAnimate') || '';  // 获取文字选择器
    this._animationOptions = {
      threshold: parseFloat(this.getAttribute('threshold')) || 0.1,
      delayFactor: parseFloat(this.getAttribute('delayFactor')) || 0.2,
      animate: this._animiateMethods[this.getAttribute('animate')] || 'fadeIn-animated-element'
    };
  }

  connectedCallback() {
    let elementsSelectors = this._elementsSelectors;

    // 如果传入的是字符串，转换为数组
    if (typeof elementsSelectors === 'string') {
      elementsSelectors = elementsSelectors.split(',').map((selector) => selector.trim());
    }

    // 如果 elementsSelectors 不是数组，直接返回
    if (!Array.isArray(elementsSelectors)) {
      console.error('elementsSelectors should be an array of valid CSS selectors');
      return;
    }

    // 如果传入了有效的文字选择器，则直接应用文字逐一显示动画
    if (this._textSelector && document.querySelector(this._textSelector)) {
      this.applyTextAnimation();
      return;  // 不再执行 applyScrollAnimation
    }

    // 否则，执行滚动动画
    this.applyScrollAnimation(elementsSelectors, this._animationOptions);
  }

  // 文字逐一显示的效果（与滚动动画类似，增加了 IntersectionObserver）
  applyTextAnimation() {
    const textContainer = document.querySelector(this._textSelector);
    if (!textContainer) return;

    // 获取原始文字内容
    const originalText = textContainer.textContent;
    textContainer.innerHTML = '';  // 清空容器内容

    // 将文字拆分为单个字母，特别处理空格
    [...originalText].forEach((letter, index) => {
      const letterSpan = document.createElement('span');
      letterSpan.textContent = letter;

      // 如果是空格，保持其存在
      if (letter === ' ') {
        letterSpan.style.display = 'inline-block';
        letterSpan.style.width = '10px';  // 确保空格占据一定的空间
      } else {
        letterSpan.style.opacity = 0;  // 初始为透明
        letterSpan.style.display = 'inline-block';
        letterSpan.style.transition = `opacity 0.1s ease ${index * 0.05}s`;  // 逐个显示字母，设置延迟
      }

      textContainer.appendChild(letterSpan);
    });

    // 使用 IntersectionObserver 来观察容器是否进入视口
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 文字进入视口时逐字显示
            const letters = textContainer.querySelectorAll('span');
            setTimeout(() => {
              letters.forEach((letter) => {
                letter.style.opacity = 1;  // 逐个字母显示
              });
            }, 100); // 延迟确保文字加载后执行
            observer.unobserve(entry.target); // 文字进入视口后，停止观察
          }
        });
      },
      { threshold: 0.1 }
    );

    // 开始观察
    observer.observe(textContainer);
  }


  // 滚动动画的实现
  applyScrollAnimation(elementsSelectors, animationOptions = { threshold: 0.1, delayFactor: 0.2, animate: 'fadeIn-animated-element' }) {
    const elements = [];

    elementsSelectors.forEach((selector) => {
      if (selector) {
        elements.push(...document.querySelectorAll(selector));
      }
    });

    if (elements.length === 0) {
      console.warn('No elements found for the given selectors');
      return;
    }

    const observedElements = new Set();

    // 为所有元素添加动画类，并设置延迟
    elements.forEach((element, index) => {
      element.classList.add(animationOptions.animate);
      element.style.setProperty('--delay', `${index * animationOptions.delayFactor}s`);
    });

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !observedElements.has(entry.target)) {
            observedElements.add(entry.target);
            setTimeout(() => {
              entry.target.classList.add('in-viewport');
            }, parseFloat(entry.target.style.getPropertyValue('--delay')) * 1000);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: animationOptions.threshold,
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  }
}

// 注册自定义元素
customElements.define('fade-in-animate', FadeInAnimate);
